// source: bookmark.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.bookmark.BookMarks', null, global);
goog.exportSymbol('proto.bookmark.IllustSimple', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.bookmark.IllustSimple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.bookmark.IllustSimple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.bookmark.IllustSimple.displayName = 'proto.bookmark.IllustSimple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.bookmark.BookMarks = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bookmark.BookMarks.repeatedFields_, null);
};
goog.inherits(proto.bookmark.BookMarks, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.bookmark.BookMarks.displayName = 'proto.bookmark.BookMarks';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.bookmark.IllustSimple.prototype.toObject = function(opt_includeInstance) {
  return proto.bookmark.IllustSimple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.bookmark.IllustSimple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.bookmark.IllustSimple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    height: jspb.Message.getFieldWithDefault(msg, 2, 0),
    width: jspb.Message.getFieldWithDefault(msg, 3, 0),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    image: jspb.Message.getFieldWithDefault(msg, 5, ""),
    pagecount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    sanity: jspb.Message.getFieldWithDefault(msg, 7, 0),
    time: jspb.Message.getFieldWithDefault(msg, 8, 0),
    title: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bookmark.IllustSimple}
 */
proto.bookmark.IllustSimple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bookmark.IllustSimple;
  return proto.bookmark.IllustSimple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bookmark.IllustSimple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bookmark.IllustSimple}
 */
proto.bookmark.IllustSimple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHeight(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setWidth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setImage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPagecount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSanity(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTime(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.bookmark.IllustSimple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.bookmark.IllustSimple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bookmark.IllustSimple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.bookmark.IllustSimple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getImage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPagecount();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getSanity();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.bookmark.IllustSimple.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.bookmark.IllustSimple} returns this
 */
proto.bookmark.IllustSimple.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 height = 2;
 * @return {number}
 */
proto.bookmark.IllustSimple.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.bookmark.IllustSimple} returns this
 */
proto.bookmark.IllustSimple.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 width = 3;
 * @return {number}
 */
proto.bookmark.IllustSimple.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.bookmark.IllustSimple} returns this
 */
proto.bookmark.IllustSimple.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 type = 4;
 * @return {number}
 */
proto.bookmark.IllustSimple.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.bookmark.IllustSimple} returns this
 */
proto.bookmark.IllustSimple.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string image = 5;
 * @return {string}
 */
proto.bookmark.IllustSimple.prototype.getImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.bookmark.IllustSimple} returns this
 */
proto.bookmark.IllustSimple.prototype.setImage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 pageCount = 6;
 * @return {number}
 */
proto.bookmark.IllustSimple.prototype.getPagecount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.bookmark.IllustSimple} returns this
 */
proto.bookmark.IllustSimple.prototype.setPagecount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 sanity = 7;
 * @return {number}
 */
proto.bookmark.IllustSimple.prototype.getSanity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.bookmark.IllustSimple} returns this
 */
proto.bookmark.IllustSimple.prototype.setSanity = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint64 time = 8;
 * @return {number}
 */
proto.bookmark.IllustSimple.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.bookmark.IllustSimple} returns this
 */
proto.bookmark.IllustSimple.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string title = 9;
 * @return {string}
 */
proto.bookmark.IllustSimple.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.bookmark.IllustSimple} returns this
 */
proto.bookmark.IllustSimple.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.bookmark.BookMarks.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.bookmark.BookMarks.prototype.toObject = function(opt_includeInstance) {
  return proto.bookmark.BookMarks.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.bookmark.BookMarks} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.bookmark.BookMarks.toObject = function(includeInstance, msg) {
  var f, obj = {
    illustsList: jspb.Message.toObjectList(msg.getIllustsList(),
    proto.bookmark.IllustSimple.toObject, includeInstance),
    time: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bookmark.BookMarks}
 */
proto.bookmark.BookMarks.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bookmark.BookMarks;
  return proto.bookmark.BookMarks.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bookmark.BookMarks} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bookmark.BookMarks}
 */
proto.bookmark.BookMarks.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = new proto.bookmark.IllustSimple;
      reader.readMessage(value,proto.bookmark.IllustSimple.deserializeBinaryFromReader);
      msg.addIllusts(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.bookmark.BookMarks.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.bookmark.BookMarks.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bookmark.BookMarks} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.bookmark.BookMarks.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIllustsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.bookmark.IllustSimple.serializeBinaryToWriter
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
};


/**
 * repeated IllustSimple illusts = 10;
 * @return {!Array<!proto.bookmark.IllustSimple>}
 */
proto.bookmark.BookMarks.prototype.getIllustsList = function() {
  return /** @type{!Array<!proto.bookmark.IllustSimple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.bookmark.IllustSimple, 10));
};


/**
 * @param {!Array<!proto.bookmark.IllustSimple>} value
 * @return {!proto.bookmark.BookMarks} returns this
*/
proto.bookmark.BookMarks.prototype.setIllustsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.bookmark.IllustSimple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bookmark.IllustSimple}
 */
proto.bookmark.BookMarks.prototype.addIllusts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.bookmark.IllustSimple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.bookmark.BookMarks} returns this
 */
proto.bookmark.BookMarks.prototype.clearIllustsList = function() {
  return this.setIllustsList([]);
};


/**
 * optional uint64 time = 8;
 * @return {number}
 */
proto.bookmark.BookMarks.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.bookmark.BookMarks} returns this
 */
proto.bookmark.BookMarks.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


goog.object.extend(exports, proto.bookmark);
